
import Vue from "vue";
import { VIEW_SIDEBAR_FIELDS_BLOCK } from "@/utils/views/view-sidebar";
import {
	getSidebarBlockDefinitionsForBrowse,
	getSidebarBlockDescription,
	getSidebarBlockName,
	getSidebarTemplateName,
	getSidebarTemplatesForBrowse,
	ISidebarBlockDefinition,
	ISidebarTemplate
} from "@/utils/views/sidebar-blocks";

export default Vue.extend({
	data(){
		return {
			fieldsBlockKey: VIEW_SIDEBAR_FIELDS_BLOCK
		};
	},
	props: {
		browseId: {
			type: Number,
			required: true
		}
	},
	computed: {
		definitions():ISidebarBlockDefinition[] {
			return getSidebarBlockDefinitionsForBrowse(this.browseId);
		},
		templates():ISidebarTemplate[] {
			return getSidebarTemplatesForBrowse(this.browseId);
		}
	},
	methods: {
		getTemplateName(key:string):string {
			return getSidebarTemplateName(key);
		},
		getName(key:string):string {
			return getSidebarBlockName(key);
		},
		getDescription(key:string):string {
			return getSidebarBlockDescription(key);
		},
		add(type:string){
			this.$emit("add", type);
		}
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
